import React, { Component } from "react"
import { Card, CardBody} from 'mdbreact';
import Modal from "../Components/Modal"
import "./Guests.css"
import FormField from "../Components/FormField"

const appUrl = 'https://api.lushplans.com/'
export default class Guests extends Component {
    constructor(props){
        super(props)

        this.state = {
            data : {},
            selectedGuest: {}
        }
    }

    componentDidMount (props, state) {
        console.log(props)
        console.log(state)
        this.setup()
    }

    componentWillReceiveProps (props) {
        console.log(props)
    }

    saveToState = (data, isValid) => {        
        const { name, value } = data
        
        const newData = Object.assign(this.state.data, {[name]: value})  
        
        this.setState({ 
          data : newData,
          showModal : false,
        //   data_status : Object.assign(this.state.data_status, {[name] : isValid})
        });
    
    }

    setup = () => {
        let user = this.props.userInfo()
        console.log(user)
        const url = appUrl + '_guests/?token=' + user.lushPlanToken + "&_id=" + user._id 
        + "&userId=" + user._id + "&weddingId=" + user.weddingId
        console.log(url)
        fetch(url)
        .then(response => {
          if (!response.ok) {
            throw Error("Network request failed")
          }
          return response
        })
        .then(d => d.json())
        .then(d => {
            console.log(d)
            this.setState(
                {data: d}
            )
        }, () => {
          //   Error
        })
    }

    onCardClick = (cardData, guestIndex) => {
        const originalCardData = Object.assign({}, cardData)
        // console.log(JSON.stringify(originalCardData))
        // console.log("GUEST CARD CLICKED")
                

        // This is when a new guest is being added
        if (guestIndex === this.state.data.guests.length){
            this.state.data.guests.push({})
        }

        this.setState({
            showModal: true,
            selectedGuest: cardData,
            selectedGuestId: guestIndex,
            selectedGuestOriginalData : originalCardData
        })
    }

    onGuestFormDataChange = (data, guestIndex) => {
        const guestArray = this.state.data.guests.map((item, index) => {
            if (index === guestIndex){
                return data
            }
            return item
        })

        this.setState({
            data : Object.assign(this.state.data, { guests : guestArray})
        })
    }

    saveGuestFormData = (index) => {        
        this.setState({
            selectedGuestOriginalData : this.state.data.guests[index]
        })
        const user = this.props.userInfo()
        // console.log('USER INFO', user)
        const url = `https://api.lushplans.com/_saveGuestsList/?token=${user.lushPlanToken}&_id=${user._id}`
        const payload = {
            userId : user._id,
            weddingId : user.weddingId,
            _id : "",
            guests : this.state.data.guests
        }
        // console.log(JSON.stringify(payload))
        fetch(url, {
            method: "POST",
            body : JSON.stringify(payload)
        }).then(res => {
            console.log(res)
            this.closeGuestModal()
        }).catch(err => {
            console.log(err)
        })
        // const url = appUrl + '_guests/?token=' + user.lushPlanToken + "&_id=" + user._id 
        // + "&userId=" + user._id + "&weddingId=" + user.weddingId
    }

    closeGuestModal = () => {
        this.onGuestFormDataChange(this.state.selectedGuestOriginalData, this.state.selectedGuestId)
        this.setState({ showModal : false })
    }

    addNewGuest = () => {
        const data = { 
            "name" : "" , "phone" : "", "email" : "", "sent" : false,
            "party" : null, "address":"", "city" : "" , "thanksSent" : false,
            "gifts" : "" ,"_id":"" , "contactMethod" : "email",
            "relationship" : "", "guestFor" : "both" , "rsvp":"no response"
        }
        this.onCardClick(data, this.state.data.guests.length)
    }

    render(){
        if (!this.props.isLoggedin()) {
            console.log('Only logged in users can see this page');
            return (
                <div className="height">
                    <hr className="spacer"></hr>
                    {this.props.authPage}
                </div>)
        }
        const {data, selectedGuest, selectedGuestId} = this.state
        if (data.guests === undefined) { return null }
        const modalBody = (
            <div>
                <GuestForm
                id={selectedGuestId}
                guest={selectedGuest}
                updateGuestData={this.onGuestFormDataChange}
                saveGuestFormData={this.saveGuestFormData}
                />
            </div>
        )
        return (
            <div className="height">
                <hr className="spacer"></hr>
                <div>
                    <div className="col-xs-12">
                        <button 
                        className="btn btn-sm lush-btn"
                        onClick={this.addNewGuest}> 
                            Add Guest 
                        </button>
                        <hr />
                    </div>
                    <div className="row">
                        {data.guests.map((guest, guestIndex) => 
                            <VendorCard 
                                key={guestIndex}
                                name={guest.name}
                                invited={guest.sent}      
                                onClick={()=>{ this.onCardClick(guest, guestIndex) }}  
                            />
                        )}                 
                    </div>
                    <Modal 
                        title={selectedGuest 
                            ? selectedGuest.name
                            : ''}
                        body={modalBody}
                        hidden={!this.state.showModal}
                        closeModal={this.closeGuestModal}
                    />
                    <br />
                </div>
            </div>
        )
    }
}

const VendorCard = props => {  
    const classes = props.invited ? "inverse-card" : ""    
    return (
      <div className={"col-md-4 col-xs-12 col-sm-6 col-lg-3 col-center-block " + classes} onClick={props.onClick}>      
        <Card>
          <CardBody>                 
              <div className="card-body">
                <h4 className="card-title text-center">
                  <strong>
                    {props.name}
                  </strong>                  
                </h4>            
              </div>              
          </CardBody>
        </Card>
        <hr />
      </div>
      )
}

const GuestForm = props => {
    const { id, guest, saveGuestFormData } = props    
    if(!guest) {
        return null;
    }
    delete guest._id
    const guestForm = {
        title : "Guest Information",
        name : "guest",
        length : 4,
        form : Object.keys(guest).map((field)=> {
            let type = "text"
            let formField = {
                name: field,
                label: field.toLocaleUpperCase(),
                type: type,
            }
            if (field === 'sent' || field === 'thanksSent' || field === "invited") {
                formField = {
                    name: field,
                    label: field.toLocaleUpperCase(),
                    type: "select",    
                    meta: {
                        options: [{label: 'Yes', value: true },{label: 'No', value: false}],
                        multiple: false
                    }            
                }
            }
            if(field === "email"){
                type = "email"
            }
            else if(field === "phone"){
                type = "tel"
            }
            
            else if(field === "relationship"){
                formField.type = "select"
                formField.meta = {
                        options: [
                            {label: 'Friend', value: "friend" },
                            {label: 'Family', value: "family" },
                            {label: 'Coworker', value: "coworker" },
                            {label: 'Religious', value: "religious" },
                            {label: 'Other', value: "other" },
                        ],
                        multiple: false
                    }            
            }
            else if(field === "rsvp"){
                formField.type = "select"
                formField.meta = {
                        options: [
                            {label: 'Attending', value: "attending" },
                            {label: 'Not Attending', value: "not attending" },
                            {label: 'No Response', value: "no response" },                            
                            {label: 'Other', value: "other" },
                        ],
                        multiple: false
                    }  
            }     
            else if(field === "guestFor")       {
                formField.type = "select"
                formField.meta = {
                        options: [
                            {label: 'Bride', value: "bride" },
                            {label: 'Groom', value: "groom" },
                            {label: 'Both', value: "both" },                            
                            {label: 'Other', value: "other" },
                        ],
                        multiple: false
                    }  
            }
            else if(field === "contactMethod"){
                formField.type = "select"
                formField.meta = {
                        options: [
                            {label: 'Phone', value: "phone" },                                                     
                            {label: 'Email', value: "email" },
                        ],
                        multiple: false
                    } 
            }
            return formField;
        })
    }

    const onInputChange = (data) => {
        const { id, updateGuestData } = props
        const { name, value } = data
        const newData = Object.assign(guest, {[name]: value})         
        updateGuestData(newData, id)
    }

    return (
        <div>
            {guestForm.form.map((item, id) => {        
                return <FormField 
                    key={id}
                    dataContainer = {item.name}
                    fieldChange = {onInputChange}
                    value = {guest[item.name] || ""}
                    field={item}
                    submitActive={()=>{}} />
            })}
            <button className="btn btn-sm lush-btn" onClick={()=>{saveGuestFormData(id)}}>SAVE</button>
        </div>
    )
}


// WEBPACK FOOTER //
// ./src/Guests/Guests.js